module.exports = __webpack_public_path__ + "img/326.329f0b93.png";